import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'components/elements';
import TimesList from '../timesList/TimesList';
import * as S from './styles';

function OppCommitment({ data }) {
  return (
    <S.OppCommitment>
      <Text className="timesList__text" as="h3" variant="body2Bold" colour="neutral.700">
        Are you available at any of these times?
      </Text>
      <TimesList listItems={data} />
    </S.OppCommitment>
  );
}

OppCommitment.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
};

export default OppCommitment;
